/** Widget action checked again during server-side siteverify. */
export const TURNSTILE_ACTION = "start-diagnostic";

/**
 * Issued only when the public site key is absent in development.
 * The verify function rejects this value.
 */
export const DEV_CAPTCHA_BYPASS_TOKEN = "dev-mock-token";
